import styled, { css } from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

export const AddToDashboardWrapper = styled.div<{ isDisabled?: boolean }>`
    position: inherit;
    top: 7px;
    right: 0;

    ${({ isDisabled }) =>
        isDisabled &&
        css`
            svg {
                path {
                    fill: ${colorsPalettes.carbon[100]} !important;
                }
            }
        `}
`;
